export default "__VITE_ASSET__Bsjcej37__"